// Roles
export const ROLE_FULL_ADMINISTRATOR = "3bbf2de3-c573-4c2b-9321-82e04ec9026c";
export const ROLE_REPORT_VIEWER = "72887fb6-d990-49e5-99df-1dcb9cdb888d";
export const ROLE_POWER_USER = "6d5038e7-97dc-43a4-9190-022f52b8b6ff";

export const SERVICE_ROLES = [
    ROLE_FULL_ADMINISTRATOR,
    ROLE_REPORT_VIEWER,
    ROLE_POWER_USER
];